/* eslint-disable react-hooks/exhaustive-deps */

import { useMediaQuery } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import theme from '../../../../config/theme';
import { useGetActivities } from '../../../edit-activities/hooks/useGetActivities';

export const useViewActivities = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const idProject = location.state.params.idProject as string;

	const matches = useMediaQuery(theme.breakpoints.down('md'));

	const { activitiesOptions } = useGetActivities();

	useEffect(() => {
		if (!idProject) navigate(-1);
	}, []);

	return {
		activitiesOptions,
		matches,
		navigate,
	};
};
